import { useMemo } from 'react';

interface UseExportNameValidationReturn {
  isValid: boolean;
  helperText?: string;
  hasError: boolean;
}

export const useExportNameValidation = (
  exportName: string
): UseExportNameValidationReturn => {
  const isValid = useMemo(() => {
    if (!exportName) return false;
    if (exportName.length > 100) return false;
    return true;
  }, [exportName]);

  const helperText = useMemo(() => {
    if (!exportName) return 'Name is required';
    if (exportName.length > 100) return 'Name must be at most 100 characters';
    return undefined;
  }, [exportName]);

  const hasError = useMemo(() => {
    if (!exportName) return true;
    if (exportName.length > 100) return true;
    return false;
  }, [exportName]);

  return {
    isValid,
    helperText,
    hasError,
  };
};
